import TagService from "@/services/tagService";
import EventBus from "@/eventBus";
import {ALERT} from '../../constants/alert.js'
export const moduleTags = {
  namespaced: true,
  state: {
    // tags is now an object grouped by tag_source (contactTags, convoTags, etc.)
    tags: {},
    manual_tagging : true,
  },

  getters: {
    //Return tags for a specific group (default: "contactTags")
   
    tags(state) {
      return state.tags["contactTags"] || [];
    },
 convoTags (state){
 return state.tags["convoTags"] || [];
 },
 osclaimsTags(state) {
   return state.tags["osclaimsTags"] || [];
 },
 osclaimsConvoTags(state) {
   return state.tags["OSclaimsconvoTags"] || [];
 },
    //Return a flattened hash map: { tag_id: tag_name }
     
    tagsHash: (state) => {
      return Object.values(state.tags)
        .flat()
        .reduce((dict, tag) => {
          dict[tag.tag_id] = tag.tag_name;
          return dict;
        }, {});
    },

    // Return a flattened hash map: { tag_id: full tag object }
    
    tagsHashnew: (state) => {
      return Object.values(state.tags)
        .flat()
        .reduce((dict, tag) => {
          dict[tag.tag_id] = tag;
          return dict;
        }, {});
    },

    // Return all tags in one flat array
    
    allTags: (state) => {
      return Object.values(state.tags).flat();
    },

    //Manual tagging state
   
    can_manual_tagging(state) {
      return state.manual_tagging;
    },

    //Get tag_id by name
     
    getTagId: (state, getters) => (name) => {
      const all = getters.allTags;
      const t = all.find((tag) => tag.tag_name === name);
      return t ? t.tag_id : null;
    },
  },

  mutations: {
    // Replace the entire tags object
  
    tags(state, value) {
      state.tags = value;
    },

    // Add or update a tag in the correct group dynamically
    
    update_Tag(state, value) {
      const group = value.tag_source || "unspecified";
      if (!state.tags[group]) {
        state.tags[group] = [];
      }

      const index = state.tags[group].findIndex(
        (tag) => tag.tag_id === value.tag_id
      );

      if (index !== -1) {
        // Update existing
        state.tags[group].splice(index, 1, value);
      } else {
        // Add new
        state.tags[group].push(value);
      }
    },

    // Delete tag by ID from all groups
    
    delete_Tag(state, tagId) {
      Object.keys(state.tags).forEach((group) => {
        const index = state.tags[group].findIndex(
          (tag) => tag.tag_id === tagId
        );
        if (index !== -1) {
          state.tags[group].splice(index, 1);
        }
      });
    },

    // Set manual tagging flag
  
    manual_tagging(state, value) {
      state.manual_tagging = value;
    },
  },

  actions: {
    // Fetch all tags from backend
   
    async getTags({ commit }) {
      try {
        const res = await TagService.getTags();
        commit("tags", res.data);
      } catch (error) {
        console.error("Error fetching tags:", error);
        EventBus.$emit("alert", {
          message: "Failed to load tags",
          type: ALERT.ERROR,
        });
      }
    },

    // Create a new tag
  
    async createTag({ dispatch }, payload) {
      try {
        await TagService.createNewTag(payload);
        EventBus.$emit("alert", {
          message: "Tag Created Successfully",
          type: ALERT.SUCCESS,
        });
        dispatch("getTags"); // refresh tags
      } catch (error) {
        console.error("Error creating tag:", error);
        EventBus.$emit("alert", {
          message: "Failed To Create New Tag",
          type: ALERT.ERROR,
        });
      }
    },

    // Update an existing tag
    
    async updateTag({ dispatch }, payload) {
      try {
        await TagService.updateTag(payload.tag_id, payload.tag_data);
        EventBus.$emit("alert", {
          message: "Tag Updated Successfully",
          type: ALERT.SUCCESS,
        });
        dispatch("getTags");
      } catch (error) {
        console.error("Error updating tag:", error);
        EventBus.$emit("alert", {
          message: "Failed To Update Tag",
          type: ALERT.ERROR,
        });
      }
    },

    // Delete a tag
     
    async deleteTag({ dispatch }, tagId) {
      try {
        await TagService.deleteTag(tagId);
        EventBus.$emit("alert", {
          message: "Tag Deleted Successfully",
          type: ALERT.SUCCESS,
        });
        dispatch("getTags");
      } catch (error) {
        console.error("Error deleting tag:", error);
        EventBus.$emit("alert", {
          message: "Failed To Delete Tag",
          type: ALERT.ERROR,
        });
      }
    },

    // Add tag to contact
    
    async addTagforContact(_, payload) {
      try {
        const response = await TagService.addTagforContact(payload);
        if (response.status === 200) {
          EventBus.$emit("alert", {
            message: "Tag Added Successfully",
            type: ALERT.SUCCESS,
          });
        }
      } catch (error) {
        console.error("Error adding tag:", error);
        EventBus.$emit("alert", {
          message: "Failed To Add Tag",
          type: ALERT.ERROR,
        });
      }
    },

    // Remove tag from contact
  
    async removeTagForContact(_, payload) {
      try {
        const response = await TagService.removeTagforContact(
          payload.contact_id,
          payload.tag_id
        );
        if (response.status === 200) {
          EventBus.$emit("alert", {
            message: "Tag Removed Successfully",
            type: ALERT.SUCCESS,
          });
        }
      } catch (error) {
        console.error("Error removing tag:", error);
        EventBus.$emit("alert", {
          message: "Failed To Remove Tag",
          type: ALERT.ERROR,
        });
      }
    },

    // Apply mass tags to multiple contacts

    async applyMassTagforContact(_, payload) {
      try {
        if (payload.contact_ids.length === 0 || payload.tag_ids.length === 0) {
          EventBus.$emit("alert", {
            message:
              payload.contact_ids.length === 0
                ? "No Contacts Selected"
                : "No Tags Selected",
            type: ALERT.WARNING,
          });
          return;
        }

        await TagService.applyMassTagforContact(payload);
        EventBus.$emit("alert", {
          message: "Tag Added Successfully",
          type: ALERT.SUCCESS,
        });
      } catch (error) {
        console.error("Error applying mass tags:", error);
        EventBus.$emit("alert", {
          message: "Failed To Add Tag",
          type: ALERT.ERROR,
        });
      }
    },
  },
};